import { DataOptions } from './data.types';
import { InsightContent } from '../../content/collection/types';
import { ChartType } from '@ecosystem/newron-client-lib';

export enum CoreContents {
  unknown = 'unknown',
  dataError = 'dataError',
  timeSeries = 'timeSeries',
  segmentation = 'segmentation',
  multiKpi = 'multiKpi',
  leaderBoard = 'leaderBoard',
  statsTable = 'statsTable',
  keyIndicators = 'keyIndicators',
  kpiTrends = 'kpiTrends',
  billboard = 'billboard',
  alertPanel = 'alertPanel',
  singleKpiTrend = 'singleKpiTrend',
  heatmap = 'heatmap',
  kpiDecompositon = 'kpiDecomposition',
}

export enum ExportFormat {
  Xlsx = 'xlsx',
  Pptx = 'pptx',
  Png = 'png',
}

export type ExportHeaderSettings = {
  customValues: [string, string][];
  settingValues: { label: string; valueKey: string }[];
  filterValues: { label: string; valueKey: string }[];
};

export type ExportOptions = {
  fileName: string;
  contentName?: string;
  fileHeaderSettings?: ExportHeaderSettings;
};

export type CollectionOptions = {
  collectionKey: string;
  type: InsightContent['type'];
  dataOptions: InsightContent['dataOptions'];
  chartName: string;
  chartType?: ChartType;
};

export type GenAiOptions = {
  endpoint?: string;
};

export type FromSettingsInstruction = {
  type: 'FromSettingsInstruction';
  instruction: string;
};

export type StringInstruction = {
  type: 'StringInstruction';
  instruction: string;
};

export type StringListInstruction = {
  type: 'StringListInstruction';
  instruction: string[];
};

export type BooleanInstruction = {
  type: 'BooleanInstruction';
  instruction: boolean;
};

export type NumberInstruction = {
  type: 'NumberInstruction';
  instruction: number;
};

export type ObjectInstruction = {
  type: 'ObjectInstruction';
  instruction: unknown;
};

export type ContentInstruction =
  | FromSettingsInstruction
  | StringInstruction
  | StringListInstruction
  | BooleanInstruction
  | NumberInstruction
  | ObjectInstruction;
export type ContentInstructions = Record<string, ContentInstruction>;

export type Content = {
  type: string;
  dataOptions?: DataOptions;
  instructions?: ContentInstructions;
};
